export default {
  Year: 4095, // Cả năm
  QuarterI: 7, // Quý I
  QuarterII: 56, // Quý II
  QuarterIII: 448, // Quý III
  QuarterIV: 3584, // Quý IV
  FirtsHalfYear: 63, // 6 tháng đầu năm
  SecondHalfYear: 4032, // 6 tháng cuố
};
